/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useMemo } from 'react';
import { generateUrl } from '../util';
import { ROUTES } from '../../constants/routes';
import AdminBreadcrumbItem, { AdminBreadcrumbItemType } from './AdminBreadcrumbItem';
import { BenchmarkingTabCodes } from '../../components/portfolio/benchmarking/BenchmarkingNavigation';

interface AdminBreadcrumbsProps {
  breadcrumbs: AdminBreadcrumbItemType[];
  initiativeId: string;
  isPortfolioTracker?: boolean;
  isBenchmarking?: boolean;
}

export const AdminBreadcrumbs = ({ breadcrumbs, initiativeId, isPortfolioTracker = false, isBenchmarking = false }: AdminBreadcrumbsProps) => {
  const baseRoute = isPortfolioTracker ? ROUTES.PORTFOLIO_TRACKER_ADMIN_SETTINGS : ROUTES.ADMIN_SETTINGS;
  
  const rootLabel = isBenchmarking ? 'Survey packs' : 'Admin Settings'
  const rootUrl = isBenchmarking
    ? generateUrl(ROUTES.PORTFOLIO_TRACKER_BENCHMARKING, {
        portfolioId: initiativeId,
        page: BenchmarkingTabCodes.PackUsage,
      })
    : generateUrl(baseRoute, { initiativeId, ...(isPortfolioTracker && { portfolioId: initiativeId }) });

  const list = useMemo(() => {
    const items: JSX.Element[] = []
    breadcrumbs.forEach((item, index) => {
      const isDisabled = index === breadcrumbs.length - 1;
      items.push(<div key={`divider-${index}`} className='mx-2'>&#47;</div>)
      items.push(
        <React.Fragment key={index}>
          <AdminBreadcrumbItem label={item.label} url={item.url} isDisabled={isDisabled}/>
        </React.Fragment>
      );
    })
    return items;
  }, [breadcrumbs])

  return <div className={'w-100 d-flex justify-content-between align-items-center'}>
    <div className='ml-2 d-flex flex-row align-items-center text-ThemeTextMedium'>
      <AdminBreadcrumbItem
        label={rootLabel}
        url={rootUrl}
      />
      {list}
    </div>
  </div>
}
